import { render, staticRenderFns } from "./edpDialog.vue?vue&type=template&id=56df6718&"
import script from "./edpDialog.vue?vue&type=script&lang=js&"
export * from "./edpDialog.vue?vue&type=script&lang=js&"
import style0 from "./edpDialog.vue?vue&type=style&index=0&id=56df6718&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports